@if (((campaign().locationsGroup && campaign().locationsGroup!.locations != undefined
&& campaign().locationsGroup!.locations.length > 0) || campaign().merchant) && campaign().reward != undefined) {
  <div class="sponsor-sentence-promo-title" *transloco="let t">
    <div class="text-line">
      <div class="text">{{ t('actions.card.sentence.youHave') }}</div>
      <div class="chip">{{ campaign().reward | loyaltyCurrency }}</div>
    </div>
    <div class="text-line">
      <div class="text">{{ t('actions.card.sentence.toSpendAt') }}</div>
      <lib-pill-logo [companyName]="numberOfLocationsI18nString()" [color]="PillColor.NEUTRAL_200"
                     [type]="PillType.NORMAL"></lib-pill-logo>
    </div>
  </div>
}
